// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3YyqU","label":"Completed_label__3mxpf"};